import dayjs from 'dayjs';

export const getUTCOffset = () => (- new Date().getTimezoneOffset() /60);

export const DayjsOffset = dayjs().utcOffset();

export const convertToUTC = (date: any) => {
    const dayjsDate: any = dayjs(date);
    return dayjsDate.utcOffset(getUTCOffset());
}

export const applyOffset = (date: any, customOffset: any = null) => {
    let offset = null;
    if(customOffset !== null){
        offset = customOffset;
    }else{
        offset = DayjsOffset;
    }
    //console.log("OFFSET: ", offset);
    const dayjsDate: any = dayjs(date);
    return dayjsDate.valueOf() + (offset * 60 * 60 * 1000);
}

export const convert = (timestamp: number, offset: any) => timestamp + (offset * 60 * 60 * 1000);

// export const converToLocal = (date: any, )

export const unapplyOffset = (date: any, offset: number | null = DayjsOffset) => {
    const dayjsDate: any = dayjs(date);
    if(offset !== undefined || offset !== null){
        //@ts-ignore
        return dayjsDate.valueOf() - (offset * 60 * 1000);
    }else{
        return dayjsDate.valueOf() - (DayjsOffset * 60 * 1000);
    }
}
